import config from 'config';
import { Conference } from 'types/models/Conference';
import Teaser, { Props as TeaserProps } from '@components/Teaser';
import ConferenceInfo from '@components/ConferenceInfo';
import ConferenceTags from '@components/ConferenceTags';
import formatDateRange from 'utils/formatDateRange';

const { routes } = config;

type Props = Omit<TeaserProps, 'topContent' | 'bottomContent' | 'href'> &
  Pick<Conference, 'type' | 'dateFrom' | 'dateTo' | 'location' | 'slug' | 'tags'> & {
    withInfo?: boolean;
  };

const ConferencePreview = ({
  slug,
  withFakeLink,
  type,
  dateFrom,
  dateTo,
  location,
  variant,
  tags,
  withInfo,
  ...props
}: Props): JSX.Element => {
  const href = { pathname: routes.conferences.name.href, query: { name: slug } };

  return (
    <Teaser
      {...props}
      variant={variant}
      href={href}
      withFakeLink={withFakeLink}
      imageText={formatDateRange(dateFrom, dateTo)}
      topContent={
        variant === 'big' || withInfo ? (
          <ConferenceInfo
            type={type}
            dateFrom={dateFrom}
            dateTo={dateTo}
            location={location}
            variant={variant}
            isPrivate={false}
          />
        ) : undefined
      }
      bottomContent={<ConferenceTags tags={tags} />}
    />
  );
};

export default ConferencePreview;
